export class Company {
  id: string;
  code: string;
  name: string;
  extendedName?: string;
  createdBy?: string;
  updatedBy?: string;
  createdAt: Date;
  updatedAt: Date;

  private spanishNames?: Record<string, string> = {
    id: "identificador",
    code: "código",
    name: "nombre",
    extendedName: "nombre extendido",
    createdBy: "creado por",
    updatedBy: "actualizado por",
    createdAt: "creado en",
    updatedAt: "actualizado en",
  };

  constructor(data?: Partial<Company>) {
    this.id = data?.id ?? "";
    this.code = data?.code ?? "";
    this.name = data?.name ?? "";
    this.extendedName = data?.extendedName ?? undefined;
    this.createdBy = data?.createdBy ?? undefined;
    this.updatedBy = data?.updatedBy ?? undefined;
    this.createdAt = data?.createdAt ? new Date(data.createdAt) : new Date();
    this.updatedAt = data?.updatedAt ? new Date(data.updatedAt) : new Date();
  }

  getSpanishName(propertyName: string): string {
    if (this.spanishNames && this.spanishNames[propertyName]) {
      return this.spanishNames[propertyName];
    }
    return propertyName;
  }

  toPlainObject(): Record<string, string | Date | undefined> {
    return {
      id: this.id,
      code: this.code,
      name: this.name,
      extendedName: this.extendedName,
      createdBy: this.createdBy,
      updatedBy: this.updatedBy,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
    };
  }
}
